import { useEffect, useState } from "react";
import useAuthStore from "../../store/useAuthStore";
import { useProfileUpdateStore } from "../../store/useProfileUpdateStore";
import { useUserStore } from "../../store/useUserStore";
import { useRegisterQuestionsStore } from "../../store/useRegisterQuestionsStore";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";


type AboutMeProps = {
  onSaveSuccess: () => void;              // ✅ callback to scroll
  
};

const AboutMe: React.FC<AboutMeProps> = ({ onSaveSuccess }) => {
  const { activeSection, setActiveSection, updateProfile } = useProfileUpdateStore();
  const { getRegisterQuestions, getQuestionByTitle } = useRegisterQuestionsStore();
  const authStore = useAuthStore.getState();
  const userId = authStore.user.id;
  const user = useUserStore((state) => state.user);
  const getUserDetails = useUserStore((state) => state.getUserDetails);

  // Local state for controlled inputs
  const [selectedAnswers, setSelectedAnswers] = useState<{ [key: string]: string | number }>({});
  const [occupation, setBio] = useState(user?.occupation || ""); // Store occupation text
  const [errors, setErrors] = useState<{ occupation?: string;
      marital_status?: string,
      intend?: string
      seeking?: string; 
      education?: string; 
      religion?: string; 
      Kids?: string; 
      ethnicity?: string; 
      bodytype?: string; 
    }>({});

  useEffect(() => {
    getRegisterQuestions();
  }, []);

  // Initialize selectedAnswers from user.user_answers
useEffect(() => {
    if (user?.user_answers?.length > 0) {
      const initialAnswers: { [key: string]: string } = {};
      user.user_answers.forEach((answer: any) => {
        initialAnswers[answer.question_id] = answer.answer_id;
      });
      setSelectedAnswers(initialAnswers);
    }
  }, [user.user_answers]); // Run when user answers are fetched

  useEffect(() => {
    if (!user || user.id !== userId) {
      getUserDetails(userId);
    }
  }, [userId, user, getUserDetails]);

  if (activeSection !== "about_me") return null;

  // Function to validate form before submission
  const validateForm = () => {
    const newErrors: {
        intend?: string; 
        occupation?: string; 
        marital_status?: string; 
        seeking?: string; 
        education?: string; 
        religion?: string; 
        Kids?: string; 
        ethnicity?: string; 
        bodytype?: string; 
} = {
   
};

    if (!occupation.trim()) newErrors.occupation = "Occupation is required.";

    const maritalQuestion = getQuestionByTitle("Relationship_status");
    if (maritalQuestion && !selectedAnswers[maritalQuestion.id]) {
      newErrors.marital_status = "Marital status is required.";
    }

    const intendQuestion = getQuestionByTitle("Looking_Relationship");
    if (intendQuestion && !selectedAnswers[intendQuestion.id]) {
      newErrors.intend = "Intend status is required.";
    }

    const seekingQuestion = getQuestionByTitle("Seeking");
    if (seekingQuestion && !selectedAnswers[seekingQuestion.id]) {
      newErrors.seeking = "Interested status is required.";
    }

    const educationQuestion = getQuestionByTitle("Education");
    if (educationQuestion && !selectedAnswers[educationQuestion.id]) {
      newErrors.education = "Education is required.";
    }

    const religionQuestion = getQuestionByTitle("Religion");
    if (religionQuestion && !selectedAnswers[religionQuestion.id]) {
      newErrors.religion = "Religion is required.";
    }

    const kidsQuestion = getQuestionByTitle("Have_kids");
    if (kidsQuestion && !selectedAnswers[kidsQuestion.id]) {
      newErrors.Kids = "Kids is required.";
    }

    const ethnicityQuestion = getQuestionByTitle("Ethnicity");
    if (ethnicityQuestion && !selectedAnswers[ethnicityQuestion.id]) {
      newErrors.ethnicity = "Ethnicity is required.";
    }

    const bodytypeQuestion = getQuestionByTitle("Body_type");
    if (bodytypeQuestion && !selectedAnswers[bodytypeQuestion.id]) {
      newErrors.bodytype = "Body type is required.";
    }
    console.log(newErrors);
    
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // Function to handle selection of marital status
  const selectOption = (questionId: number, answerId: number) => {
    setSelectedAnswers((prev) => ({
      ...prev,
      [questionId]: answerId, // Store the selected answer for the question
    }));
  };

  // Handle save button click
  const handleSave = async () => {
    if (!validateForm()) return;

    const updatedData = {
      occupation, // Include occupation in the update
      questions: Object.entries(selectedAnswers).map(([question_id, answer_id]) => ({
        question_id,
        answer_id,
      })),
    };
    try {
      await updateProfile(userId, updatedData);
      getUserDetails(userId);
  
      toast.success("Information updated successfully!");
      onSaveSuccess(); 
       setActiveSection(null); // Uncomment to close
    } catch (error) {
      console.log(error);
      
      toast.error("Failed to update Information. Please try again.");
    }
  };
  const maritalQuestion = getQuestionByTitle("Relationship_status");
  const maritalQuestionId = maritalQuestion?.id; // Store it once to avoid multiple calls

  const intendQuestion = getQuestionByTitle("Looking_Relationship");
  const intendQuestionId = intendQuestion?.id; // Store it once to avoid multiple calls

  const seekingQuestion = getQuestionByTitle("Seeking");
  const seekingQuestionId=seekingQuestion?.id;

  const educationQuestion = getQuestionByTitle("Education");
  const educationQuestionId=educationQuestion?.id;

  const religionQuestion = getQuestionByTitle("Religion");
  const religionQuestionId=religionQuestion?.id;

  const kidsQuestion = getQuestionByTitle("Have_kids");
  const kidsQuestionId=religionQuestion?.id;

  const ethnicityQuestion = getQuestionByTitle("Ethnicity");
  const ethnicityQuestionId=ethnicityQuestion?.id;

  const bodytypeQuestion = getQuestionByTitle("Body_type");
  const bodytypeQuestionId=bodytypeQuestion?.id;

console.log( user.user_answers);


return (
  <div className="card border mb-3 filter-container">
    <div className="border-bottom pb-4 mb-4 d-flex w-100 align-items-center gap-3">
      <h4 className="mb-0">About Me</h4>
      <button 
        type="button"
        onClick={() => setActiveSection(null)}
        className="btn_close_cross_btn ms-auto"
      >
        <i className="fa-solid fa-xmark"></i>
      </button>
    </div>
    
    <div className="accordion" id="accordionAboutMe">
      {/* Relationship Status */}
      <div className="accordion-item">
        <h2 className="accordion-header">
          <button className={`accordion-button ${errors.marital_status ? '' : ''}`} type="button" data-bs-toggle="collapse"
            data-bs-target="#relationshipStatusCollapse" aria-expanded="true"
            aria-controls="relationshipStatusCollapse">
            Relationship Status
          </button>
        </h2>
        <div id="relationshipStatusCollapse" className={`accordion-collapse collapse ${errors.marital_status ? 'show' : 'show'}`}>
          <div className="accordion-body border-bottom pb-3 mb-3">
            {maritalQuestion?.questions_options.map((option) => {
              const isChecked =
                maritalQuestionId &&
                (selectedAnswers[maritalQuestionId] == option.id ||
                 user.user_answers.some(
                   (answer: any) => Number(answer.question_id) === maritalQuestionId && Number(answer.answer_id) === option.id
                 ));

              return (
                <div key={option.id} className="ps-0 form-check d-flex justify-content-between align-items-center">
                  <label className="form-check-label mb-0" htmlFor={`marital-${option.id}`}>
                    {option.option}
                  </label>
                  <input
                    className="form-check-input ms-2"
                    type="radio"
                    name="maritalStatus"
                    id={`marital-${option.id}`}
                    defaultChecked={isChecked}
                    onChange={() => selectOption(option.question_id, option.id)}
                  />
                </div>
              );
            })}
            {errors.marital_status && <p className="text-red-500 text-sm">{errors.marital_status}</p>}
          </div>
        </div>
      </div>

      {/* Intent */}
      <div className="accordion-item">
        <h2 className="accordion-header">
          <button className={`accordion-button ${errors.intend ? '' : 'collapsed'}`} type="button" data-bs-toggle="collapse"
            data-bs-target="#intentCollapse" aria-expanded="false"
            aria-controls="intentCollapse">
            Intent
          </button>
        </h2>
        <div id="intentCollapse" className={`accordion-collapse collapse ${errors.intend ? 'show' : ''}`}>
          <div className="accordion-body border-bottom pb-3 mb-3">
            {intendQuestion?.questions_options.map((option) => {
              const isCheckedintend =
                intendQuestionId &&
                (selectedAnswers[intendQuestionId] == option.id ||
                 user.user_answers.some(
                   (answer: any) => Number(answer.question_id) == Number(intendQuestionId) && Number(answer.answer_id) == Number(option.id)
                 ));

              return (
                <div key={option.id} className="ps-0 form-check d-flex justify-content-between align-items-center">
                  <label className="form-check-label mb-0" htmlFor={`intend-${option.id}`}>
                    {option.option}
                  </label>
                  <input
                    className="form-check-input ms-2"
                    type="radio"
                    name="intend"
                    id={`intend-${option.id}`}
                    defaultChecked={isCheckedintend}
                    onChange={() => selectOption(option.question_id, option.id)}
                  />
                </div>
              );
            })}
            {errors.intend && <p className="text-red-500 text-sm">{errors.intend}</p>}
          </div>
        </div>
      </div>

      {/* Interested In */}
      <div className="accordion-item">
        <h2 className="accordion-header">
          <button className={`accordion-button ${errors.seeking ? '' : 'collapsed'}`} type="button" data-bs-toggle="collapse"
            data-bs-target="#interestedCollapse" aria-expanded="false"
            aria-controls="interestedCollapse">
            Interested In
          </button>
        </h2>
        <div id="interestedCollapse" className={`accordion-collapse collapse ${errors.seeking ? 'show' : ''}`}>
          <div className="accordion-body border-bottom pb-3 mb-3">
            {seekingQuestion?.questions_options.map((option) => {
              const isCheckedseeking =
                seekingQuestionId &&
                (selectedAnswers[seekingQuestionId] == option.id ||
                 user.user_answers.some(
                   (answer: any) => Number(answer.question_id) == seekingQuestionId && Number(answer.answer_id) == option.id
                 ));

              return (
                <div key={option.id} className="ps-0 form-check d-flex justify-content-between align-items-center">
                  <label className="form-check-label mb-0" htmlFor={`seeking-${option.id}`}>
                    {option.option}
                  </label>
                  <input
                    className="form-check-input ms-2"
                    type="radio"
                    name="seeking"
                    id={`seeking-${option.id}`}
                    defaultChecked={isCheckedseeking}
                    onChange={() => selectOption(option.question_id, option.id)}
                  />
                </div>
              );
            })}
            {errors.seeking && <p className="text-red-500 text-sm">{errors.seeking}</p>}
          </div>
        </div>
      </div>

      {/* Education */}
      <div className="accordion-item">
        <h2 className="accordion-header">
          <button className={`accordion-button ${errors.education ? '' : 'collapsed'}`} type="button" data-bs-toggle="collapse"
            data-bs-target="#educationCollapse" aria-expanded="false"
            aria-controls="educationCollapse">
            Education
          </button>
        </h2>
        <div id="educationCollapse" className={`accordion-collapse collapse ${errors.education ? 'show' : ''}`}>
          <div className="accordion-body border-bottom pb-3 mb-3">
            {educationQuestion?.questions_options.map((option) => {
              const isCheckededucation =
                educationQuestionId &&
                (selectedAnswers[educationQuestionId] == option.id ||
                 user.user_answers.some(
                   (answer: any) => Number(answer.question_id) === educationQuestionId && Number(answer.answer_id) === option.id
                 ));

              return (
                <div key={option.id} className="ps-0 form-check d-flex justify-content-between align-items-center">
                  <label className="form-check-label mb-0" htmlFor={`education-${option.id}`}>
                    {option.option}
                  </label>
                  <input
                    className="form-check-input ms-2"
                    type="radio"
                    name="education"
                    id={`education-${option.id}`}
                    defaultChecked={isCheckededucation}
                    onChange={() => selectOption(option.question_id, option.id)}
                  />
                </div>
              );
            })}
            {errors.education && <p className="text-red-500 text-sm">{errors.education}</p>}
          </div>
        </div>
      </div>

      {/* Occupation */}
      <div className="accordion-item">
        <h2 className="accordion-header">
          <button className={`accordion-button ${errors.occupation ? '' : 'collapsed'}`} type="button" data-bs-toggle="collapse"
            data-bs-target="#occupationCollapse" aria-expanded="false"
            aria-controls="occupationCollapse">
            Occupation
          </button>
        </h2>
        <div id="occupationCollapse" className={`accordion-collapse collapse ${errors.occupation ? 'show' : ''}`}>
          <div className="accordion-body border-bottom pb-3 mb-3">
            <div className="mb-3">
              <textarea
                value={occupation}
                onChange={(e) => setBio(e.target.value)}
                className="w-full mt-1 p-2 border rounded w-100"
                placeholder="Write your occupation..."
              />
              {errors.occupation && <p className="text-red-500 text-sm">{errors.occupation}</p>}
            </div>
          </div>
        </div>
      </div>

      {/* Religion */}
      <div className="accordion-item">
        <h2 className="accordion-header">
          <button className={`accordion-button ${errors.religion ? '' : 'collapsed'}`} type="button" data-bs-toggle="collapse"
            data-bs-target="#religionCollapse" aria-expanded="false"
            aria-controls="religionCollapse">
            Religion
          </button>
        </h2>
        <div id="religionCollapse" className={`accordion-collapse collapse ${errors.religion ? 'show' : ''}`}>
          <div className="accordion-body border-bottom pb-3 mb-3">
            {religionQuestion?.questions_options.map((option) => {
              const isCheckedreligion =
                religionQuestionId &&
                (selectedAnswers[religionQuestionId] == option.id ||
                 user.user_answers.some(
                   (answer: any) => Number(answer.question_id) === religionQuestionId && Number(answer.answer_id) === option.id
                 ));

              return (
                <div key={option.id} className="ps-0 form-check d-flex justify-content-between align-items-center">
                  <label className="form-check-label mb-0" htmlFor={`religion-${option.id}`}>
                    {option.option}
                  </label>
                  <input
                    className="form-check-input ms-2"
                    type="radio"
                    name="religion"
                    id={`religion-${option.id}`}
                    defaultChecked={isCheckedreligion}
                    onChange={() => selectOption(option.question_id, option.id)}
                  />
                </div>
              );
            })}
            {errors.religion && <p className="text-red-500 text-sm">{errors.religion}</p>}
          </div>
        </div>
      </div>

       {/* Kids */}
      <div className="accordion-item">
        <h2 className="accordion-header">
          <button className={`accordion-button ${errors.Kids ? '' : 'collapsed'}`} type="button" data-bs-toggle="collapse"
            data-bs-target="#kidsCollapse" aria-expanded="false"
            aria-controls="kidsCollapse">
            Kids
          </button>
        </h2>
        <div id="kidsCollapse" className={`accordion-collapse collapse ${errors.Kids ? 'show' : ''}`}>
          <div className="accordion-body border-bottom pb-3 mb-3">
            {kidsQuestion?.questions_options.map((option) => {
              const isCheckedkids =
                kidsQuestionId &&
                (selectedAnswers[kidsQuestionId] == option.id ||
                 user.user_answers.some(
                   (answer: any) => Number(answer.question_id) === kidsQuestionId && Number(answer.answer_id) === option.id
                 ));

              return (
                <div key={option.id} className="ps-0 form-check d-flex justify-content-between align-items-center">
                  <label className="form-check-label mb-0" htmlFor={`religion-${option.id}`}>
                    {option.option}
                  </label>
                  <input
                    className="form-check-input ms-2"
                    type="radio"
                    name="religion"
                    id={`religion-${option.id}`}
                    defaultChecked={isCheckedkids}
                    onChange={() => selectOption(option.question_id, option.id)}
                  />
                </div>
              );
            })}
            {errors.Kids && <p className="text-red-500 text-sm">{errors.Kids}</p>}
          </div>
        </div>
      </div>

      {/* Ethnicity */}
      <div className="accordion-item">
        <h2 className="accordion-header">
          <button className={`accordion-button ${errors.ethnicity ? '' : 'collapsed'}`} type="button" data-bs-toggle="collapse"
            data-bs-target="#ethnicityCollapse" aria-expanded="false"
            aria-controls="ethnicityCollapse">
            Ethnicity
          </button>
        </h2>
        <div id="ethnicityCollapse" className={`accordion-collapse collapse ${errors.ethnicity ? 'show' : ''}`}>
          <div className="accordion-body border-bottom pb-3 mb-3">
            {ethnicityQuestion?.questions_options.map((option) => {
              const isCheckedethnicity =
                ethnicityQuestionId &&
                (selectedAnswers[ethnicityQuestionId] == option.id ||
                 user.user_answers.some(
                   (answer: any) => Number(answer.question_id) === ethnicityQuestionId && Number(answer.answer_id) === option.id
                 ));

              return (
                <div key={option.id} className="ps-0 form-check d-flex justify-content-between align-items-center">
                  <label className="form-check-label mb-0" htmlFor={`ethnicity-${option.id}`}>
                    {option.option}
                  </label>
                  <input
                    className="form-check-input ms-2"
                    type="radio"
                    name="ethnicity"
                    id={`ethnicity-${option.id}`}
                    defaultChecked={isCheckedethnicity}
                    onChange={() => selectOption(option.question_id, option.id)}
                  />
                </div>
              );
            })}
            {errors.ethnicity && <p className="text-red-500 text-sm">{errors.ethnicity}</p>}
          </div>
        </div>
      </div>

      {/* Body Type */}
      <div className="accordion-item">
        <h2 className="accordion-header">
          <button className={`accordion-button ${errors.bodytype ? '' : 'collapsed'}`} type="button" data-bs-toggle="collapse"
            data-bs-target="#bodyTypeCollapse" aria-expanded="false"
            aria-controls="bodyTypeCollapse">
            Body Type
          </button>
        </h2>
        <div id="bodyTypeCollapse" className={`accordion-collapse collapse ${errors.bodytype ? 'show' : ''}`}>
          <div className="accordion-body border-bottom pb-3 mb-3">
            {bodytypeQuestion?.questions_options.map((option) => {
              const isCheckedbodytype =
                bodytypeQuestionId &&
                (selectedAnswers[bodytypeQuestionId] == option.id ||
                 user.user_answers.some(
                   (answer: any) => Number(answer.question_id) === bodytypeQuestionId && Number(answer.answer_id) === option.id
                 ));

              return (
                <div key={option.id} className="ps-0 form-check d-flex justify-content-between align-items-center">
                  <label className="form-check-label mb-0" htmlFor={`bodytype-${option.id}`}>
                    {option.option}
                  </label>
                  <input
                    className="form-check-input ms-2"
                    type="radio"
                    name="bodytype"
                    id={`bodytype-${option.id}`}
                    defaultChecked={isCheckedbodytype}
                    onChange={() => selectOption(option.question_id, option.id)}
                  />
                </div>
              );
            })}
            {errors.bodytype && <p className="text-red-500 text-sm">{errors.bodytype}</p>}
          </div>
        </div>
      </div>
    </div>

    {/* Save Button */}
    <button
      onClick={handleSave}
      className="btn btn-outline-primary w-100 mt-3"
    >
      Save Changes
    </button>
  </div>
);
};

export default AboutMe;
